import BasicDomain from "./BasicDomain";
import * as yup from 'yup';

export default class AlternateIdentifier extends BasicDomain {
    static DEFAULTS = {
        taxonomy: null,
        system: null,
        identifier: '',
        primary: false
    }

    static VALIDATION_SCHEMA = yup.object({
        taxonomy: yup.object().required('Taxonomy is required'),
        system: yup.object().required('Taxonomy system is required'),
        identifier: yup.string().required('Identifier is required')
    }).required();

    constructor(props) {
        super('AlternateIdentifier', props, AlternateIdentifier.DEFAULTS);
    }

    inspect = () => {
        return AlternateIdentifier.VALIDATION_SCHEMA.validate(this, { abortEarly: false });
    }
}

if (global.Parse.Object.registerSubclass) {
    global.Parse.Object.registerSubclass('AlternateIdentifier', AlternateIdentifier);
}